var _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutcomes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.28037,
    height: 25.8213,
    rx: 3.14019,
    transform: "matrix(0.866025 0.5 0.5 -0.866025 0.0522461 23.5454)",
    fill: "#A4FC67"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.28037,
    height: 16.0447,
    rx: 3.14019,
    transform: "matrix(0.866025 0.5 0.5 -0.866025 9.86621 23.5454)",
    fill: "#A4FC67",
    fillOpacity: 0.66
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.28037,
    height: 7.12643,
    rx: 3.14019,
    transform: "matrix(0.866025 0.5 0.5 -0.866025 18.8149 23.5454)",
    fill: "#A4FC67",
    fillOpacity: 0.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcomes);
export default __webpack_public_path__ + "static/media/outcomes.99ac3aa6ae1517ae3ec2a85d151931c3.svg";
export { ForwardRef as ReactComponent };